/**
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/

// 咨询-预约咨询
const homepage = resolve =>
  require(['../../../views/personalCenter/homePage'], resolve)

export default [
  // 预约咨询
  {
    path: '/homepage',
    component: homepage
  }
]



// WEBPACK FOOTER //
// ./src/router/page/personalCenter/homePage.js